import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import {
  createSubjectDataType,
  type ISubjectData,
  type ISubjectDataType,
  SubjectDataTypes,
} from './SubjectDataTypes.ts';

const AttorneyApplicantDataTypesAll: Record<string, ISubjectDataType> = {
  // ID File di procura
  attorneyDocumentAttachmentId: createSubjectDataType(
    'attorneyDocumentAttachmentId',
    {
      label: 'Documento di procura',
      type: Datatype.File,
    },
  ),
};

type AttorneySubjectDataTypesSchema = typeof AttorneyApplicantDataTypesAll;
export type AttorneySubjectDataKey = keyof AttorneySubjectDataTypesSchema &
  keyof typeof SubjectDataTypes.Map;

export type IAttorneySubjectData = ISubjectData & {
  attorneyDocumentAttachmentId: string | undefined;
};

export class AttorneyApplicantDataTypes {
  static readonly Map = {
    ...SubjectDataTypes.Map,
    ...AttorneyApplicantDataTypesAll,
  };

  static readonly List = Object.values(this.Map);

  static readonly Codes = Object.keys(this.Map) as Array<keyof typeof this.Map>;

  /**
   * Codici specifici dei dati del procuratore (esclusi quelli comuni a tutti i soggetti).
   */
  static readonly SpecificCode = Object.keys(
    AttorneyApplicantDataTypesAll,
  ) as Array<keyof AttorneySubjectDataTypesSchema>;

  /**
   * Ritorna true se la chiave passata è una chiave di dati del procuratore.
   */
  static isAttorneyDataCode(
    key: string | undefined,
  ): key is AttorneySubjectDataKey {
    if (!key) return false;
    return AttorneyApplicantDataTypes.Codes.includes(
      key as AttorneySubjectDataKey,
    );
  }
}
